import React from 'react';

// constants
import components from './components';

class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`Error in component ${this.props.componentName}:`, error.message);
    console.error('Component stack:', errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#fee', border: '1px solid #f00', margin: '10px 0' }}>
          <strong>Error in {this.props.componentName}:</strong>
          <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>{this.state.error?.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const ComponentRender = ({ type, component, options = {} }) => {
  if (!component) return null;

  const { __typename, ...data } = component;

  const RenderedComponent = components[type]?.[__typename];

  if (RenderedComponent) {
    return (
      <ComponentErrorBoundary componentName={__typename}>
        <RenderedComponent {...data} {...options} />
      </ComponentErrorBoundary>
    );
  } else {
    console.warn(`No component render found for type: ${type}.${__typename}`, data);
  }

  return null;
};
export default ComponentRender;
